export class Trpconsignmentinv {
    public CN_INVOICE_ID!: number;
    public CN_LOC!: string;
    public CN_NO!: string;
    public CN_INVNO!: string;
    public CN_INVDATE!: string; // Date;
    // Date;
    public CN_INVVALUE!: number;
    public CN_NETVALUE!: number;
    public CN_ITMDESC!: string;
    public CN_BOXTYPE!: string;
    public CN_NOB!: number;
    public CN_PARTNO!: string;
    public CN_QTY!: number;
    public CN_H!: number;
    public CN_L!: number;
    public CN_W!: number;
    public CN_CFT!: number;
    public CN_ACTWT!: number;
    public CN_CHGWT!: number;
    public TS!: Date;
    public CN_EWAYBILLNO!: string;
    public CN_EWAYEXPIRYDT!: string; //Date;
    //Date;
    public CN_PARTNO2!: string;
    public CN_PARTNO3!: string;
    public CN_PARTQTY1!: number;
    public CN_PARTQTY2!: number;
    public CN_PARTQTY3!: number;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string;
    public UPDATED_DATE!: string;
    public IS_ACTIVE!: boolean;
}